import SingleSelectQuestion from './SingleSelectQuestion';

export default SingleSelectQuestion;
